import React, { useState, useEffect } from 'react';
import { TileLayer, useMap } from 'react-leaflet';

/**
 * AutoTopoTileLayer — alterna automaticamente entre OpenTopoMap (até zoom 17)
 * e imagens de satélite gratuitas (Esri World Imagery, até zoom 19) à medida
 * que o utilizador faz mais zoom.
 *
 * Não precisa de API key. As tiles Esri World Imagery são gratuitas para uso
 * não comercial.
 */
const TOPO_MAX = 17;
const SAT_MAX = 19;

const AutoTopoTileLayer = ({ thresholdZoom = TOPO_MAX }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(() => map.getZoom() ?? 13);

  useEffect(() => {
    const onZoom = () => setZoom(map.getZoom());
    map.on('zoomend', onZoom);
    map.on('zoom', onZoom);
    return () => {
      map.off('zoomend', onZoom);
      map.off('zoom', onZoom);
    };
  }, [map]);

  const useSatellite = zoom > thresholdZoom;

  if (useSatellite) {
    return (
      <>
        <TileLayer
          key="esri-sat"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution='Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics'
          maxZoom={SAT_MAX}
          maxNativeZoom={SAT_MAX}
        />
        {/* Overlay com nomes de estradas/locais para legibilidade */}
        <TileLayer
          key="esri-labels"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
          maxZoom={SAT_MAX}
          maxNativeZoom={SAT_MAX}
          opacity={0.9}
        />
      </>
    );
  }

  return (
    <TileLayer
      key="topo"
      url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      attribution='Map data: &copy; OpenStreetMap, SRTM | Style: &copy; OpenTopoMap (CC-BY-SA)'
      maxZoom={SAT_MAX}
      maxNativeZoom={TOPO_MAX}
    />
  );
};

export default AutoTopoTileLayer;
